import React from "react";
import { Row, Col } from 'react-grid-system';
import ReactPlayer from 'react-player';

function Teaching02() {
	return (
	<div className="content_inpage">
		<div className="pagesize">
			<ul className="bread">
				<li><a href="/">首頁</a></li>						
				<li><a href="/container/teaching">教學&QA</a></li>
			</ul>		
					
			<div id="tab_con">
				<div className="tab_box active">
					<h2 className="tit_main">教學</h2>
					<div className="content_box">
						
						
						<div className="cp_fix cp_manual">
							<h4>操作手冊</h4>
							<div className="cp_box">
								<div className="cp_link">
									{/* <Link to={"/container/teaching/Teaching0201"}>Lucia Mini</Link>
									<Link to={"/container/teaching/Teaching0201"}>Lucia</Link>
									<Link to={"/container/teaching/Teaching0202"}>智慧家電</Link>
									<Link to={"/container/teaching/Teaching0203"}>代步車</Link>
									<Link to={"/container/teaching/Teaching0204"}>情境模式</Link>
									<Link to={"/container/teaching/Teaching0205"}>聲控兌品</Link> */}
									<a href={process.env.REACT_APP_FILM_API + "1.引導頁.pdf"} target="_blank" rel="noreferrer">1.引導頁</a>
									<a href={process.env.REACT_APP_FILM_API + "2.下載及會員登入.pdf"} target="_blank" rel="noreferrer">2.下載及會員登入</a>
									<a href={process.env.REACT_APP_FILM_API + "3.最新消息.pdf"} target="_blank" rel="noreferrer">3.最新消息</a>
									<a href={process.env.REACT_APP_FILM_API + "4.搜尋.pdf"} target="_blank" rel="noreferrer">4.搜尋</a>
									<a href={process.env.REACT_APP_FILM_API + "5.音箱新用戶引導.pdf"} target="_blank" rel="noreferrer">5.音箱新用戶引導</a>
									<a href={process.env.REACT_APP_FILM_API + "6.1智慧家電教學.pdf"} target="_blank" rel="noreferrer">6.1智慧家電教學</a>
									<a href={process.env.REACT_APP_FILM_API + "6.2智慧音箱教學.pdf"} target="_blank" rel="noreferrer">6.2智慧音箱教學</a>
									<a href={process.env.REACT_APP_FILM_API + "6.3音箱功能介紹.pdf"} target="_blank" rel="noreferrer">6.3音箱功能介紹</a>
									<a href={process.env.REACT_APP_FILM_API + "6.4智慧家電功能介紹.pdf"} target="_blank" rel="noreferrer">6.4智慧家電功能介紹</a>
									<a href={process.env.REACT_APP_FILM_API + "7.會員.pdf"} target="_blank" rel="noreferrer">7.會員</a>
									<a href={process.env.REACT_APP_FILM_API + "7.1情境教學.pdf"} target="_blank" rel="noreferrer">7.1情境教學</a>
									<a href={process.env.REACT_APP_FILM_API + "7.2聲控兌品.pdf"} target="_blank" rel="noreferrer">7.2聲控兌品</a>
									<a href={process.env.REACT_APP_FILM_API + "7.3我的日程.pdf"} target="_blank" rel="noreferrer">7.3日程表</a>
									<a href={process.env.REACT_APP_FILM_API + "7.4每日必聽.pdf"} target="_blank" rel="noreferrer">7.4每日必聽</a>
									<a href={process.env.REACT_APP_FILM_API + "7.5待辦事項.pdf"} target="_blank" rel="noreferrer">7.5代辦事項</a>
									<a href={process.env.REACT_APP_FILM_API + "7.6貼心提醒.pdf"} target="_blank" rel="noreferrer">7.6貼心提醒</a>
									<a href={process.env.REACT_APP_FILM_API + "7.7鬧鐘.pdf"} target="_blank" rel="noreferrer">7.7鬧鐘</a>
									<a href={process.env.REACT_APP_FILM_API + "8.技能啟用.pdf"} target="_blank" rel="noreferrer">8.技能啟用</a>
									<a href={process.env.REACT_APP_FILM_API + "8.1.技能介紹.pdf"} target="_blank" rel="noreferrer">8.1.技能介紹</a>
									<a href={process.env.REACT_APP_FILM_API + "9.內容.pdf"} target="_blank" rel="noreferrer">9.內容</a>
									<a href={process.env.REACT_APP_FILM_API + "10.綁約固網.pdf"} target="_blank" rel="noreferrer">10.線上申租方案</a>
									<a href={process.env.REACT_APP_FILM_API + "11.資費相關.pdf"} target="_blank" rel="noreferrer">11.小額付款/信用卡付費</a>
								</div>
							</div>
						</div>
						<div className="cp_fix cp_manual">
							<h4>操作影片</h4>
							<div className="cp_box">
								<div className="cp_link video_guide">
								
								<Row>
								<Col xs={0.5}></Col>
							
								<Col xs={12} md={3}>
									<label style={{height:"10px"}}>1.引導頁</label>
									{/*<ReactPlayer muted={true} controls={true} playing={true} url={process.env.REACT_APP_FILM_API + listItems[0].ent_film} width="100%" height="auto" />*/}
									<ReactPlayer muted={true} controls={true} playing={false} url={process.env.REACT_APP_FILM_API + "1.引導頁.mp4"} width="100%" height="150px" />
								</Col>
								<Col xs={1}></Col>
								<Col xs={12} md={3}>
									<label>2.下載及會員登入</label>
									{/*<ReactPlayer muted={true} controls={true} playing={true} url={process.env.REACT_APP_FILM_API + listItems[0].ent_film} width="100%" height="auto" />*/}
									<ReactPlayer muted={true} controls={true} playing={false} url={process.env.REACT_APP_FILM_API + "2.1下載及會員登入.mp4"} width="100%" height="150px" />
								</Col>
								<Col xs={1}></Col>
								<Col xs={12} md={3}>
									<label className="">3.最新消息</label>
									{/*<ReactPlayer muted={true} controls={true} playing={true} url={process.env.REACT_APP_FILM_API + listItems[0].ent_film} width="100%" height="auto" />*/}
									<ReactPlayer muted={true} controls={true} playing={false} url={process.env.REACT_APP_FILM_API + "3.最新消息.mp4"} width="100%" height="150px" />
								</Col>
								<Col xs={0.5}></Col>
								</Row>
								<Row>
								<Col xs={0.5}></Col>
							
								<Col xs={12} md={3}>
									<label>4.搜尋</label>
									{/*<ReactPlayer muted={true} controls={true} playing={true} url={process.env.REACT_APP_FILM_API + listItems[0].ent_film} width="100%" height="auto" />*/}
									<ReactPlayer muted={true} controls={true} playing={false} url={process.env.REACT_APP_FILM_API + "4.搜尋.mp4"} width="100%" height="150px" />
								</Col>
								<Col xs={1}></Col>
								<Col xs={12} md={3}>
									<label>5.音箱新用戶引導</label>
									{/*<ReactPlayer muted={true} controls={true} playing={true} url={process.env.REACT_APP_FILM_API + listItems[0].ent_film} width="100%" height="auto" />*/}
									<ReactPlayer muted={true} controls={true} playing={false} url={process.env.REACT_APP_FILM_API + "5.音箱新用戶引導.mp4"} width="100%" height="150px" />
								</Col>
								<Col xs={1}></Col>
								<Col xs={12} md={3}>
									<label className="">6.1 智慧家電教學</label>
									{/*<ReactPlayer muted={true} controls={true} playing={true} url={process.env.REACT_APP_FILM_API + listItems[0].ent_film} width="100%" height="auto" />*/}
									<ReactPlayer muted={true} controls={true} playing={false} url={process.env.REACT_APP_FILM_API + "6.1智慧家電教學.mp4"} width="100%" height="150px" />
								</Col>
								<Col xs={0.5}></Col>
								</Row>

								<Row>
								<Col xs={0.5}></Col>
							
								<Col xs={12} md={3}>
									<label>6.2 智慧音箱教學</label>
									{/*<ReactPlayer muted={true} controls={true} playing={true} url={process.env.REACT_APP_FILM_API + listItems[0].ent_film} width="100%" height="auto" />*/}
									<ReactPlayer muted={true} controls={true} playing={false} url={process.env.REACT_APP_FILM_API + "6.2智慧音箱教學.mp4"} width="100%" height="150px" />
								</Col>
								<Col xs={1}></Col>
								<Col xs={12} md={3}>
									<label>6.3 音箱功能介紹</label>
									{/*<ReactPlayer muted={true} controls={true} playing={true} url={process.env.REACT_APP_FILM_API + listItems[0].ent_film} width="100%" height="auto" />*/}
									<ReactPlayer muted={true} controls={true} playing={false} url={process.env.REACT_APP_FILM_API + "6.3智慧音箱功能介紹.mp4"} width="100%" height="150px" />
								</Col>
								<Col xs={1}></Col>
								<Col xs={12} md={3}>
									<label className="">6.4 智慧家電功能介紹</label>
									{/*<ReactPlayer muted={true} controls={true} playing={true} url={process.env.REACT_APP_FILM_API + listItems[0].ent_film} width="100%" height="auto" />*/}
									<ReactPlayer muted={true} controls={true} playing={false} url={process.env.REACT_APP_FILM_API + "6.4智慧家電APP功能介紹.mp4"} width="100%" height="150px" />
								</Col>
								<Col xs={0.5}></Col>
								</Row>

								<Row>
								<Col xs={0.5}></Col>
							
								<Col xs={12} md={3}>
									<label>7.會員</label>
									{/*<ReactPlayer muted={true} controls={true} playing={true} url={process.env.REACT_APP_FILM_API + listItems[0].ent_film} width="100%" height="auto" />*/}
									<ReactPlayer muted={true} controls={true} playing={false} url={process.env.REACT_APP_FILM_API + "7.會員.mp4"} width="100%" height="150px" />
								</Col>
								<Col xs={1}></Col>
								<Col xs={12} md={3}>
									<label>7.1 情境教學</label>
									{/*<ReactPlayer muted={true} controls={true} playing={true} url={process.env.REACT_APP_FILM_API + listItems[0].ent_film} width="100%" height="auto" />*/}
									<ReactPlayer muted={true} controls={true} playing={false} url={process.env.REACT_APP_FILM_API + "7.1情境教學.mp4"} width="100%" height="150px" />
								</Col>
								<Col xs={1}></Col>
								<Col xs={12} md={3}>
									<label className="">7.2 聲控兌品</label>
									{/*<ReactPlayer muted={true} controls={true} playing={true} url={process.env.REACT_APP_FILM_API + listItems[0].ent_film} width="100%" height="auto" />*/}
									<ReactPlayer muted={true} controls={true} playing={false} url={process.env.REACT_APP_FILM_API + "7.2聲控兌品.mp4"} width="100%" height="150px" />
								</Col>
								<Col xs={0.5}></Col>
								</Row>

								<Row>
								<Col xs={0.5}></Col>
							
								<Col xs={12} md={3}>
									<label>7.3 我的日程</label>
									{/*<ReactPlayer muted={true} controls={true} playing={true} url={process.env.REACT_APP_FILM_API + listItems[0].ent_film} width="100%" height="auto" />*/}
									<ReactPlayer muted={true} controls={true} playing={false} url={process.env.REACT_APP_FILM_API + "7.3我的日程.mp4"} width="100%" height="150px" />
								</Col>
								<Col xs={1}></Col>
								<Col xs={12} md={3}>
									<label>7.4 待辦事項</label>
									{/*<ReactPlayer muted={true} controls={true} playing={true} url={process.env.REACT_APP_FILM_API + listItems[0].ent_film} width="100%" height="auto" />*/}
									<ReactPlayer muted={true} controls={true} playing={false} url={process.env.REACT_APP_FILM_API + "7.4代辦事項.mp4"} width="100%" height="150px" />
								</Col>
								<Col xs={1}></Col>
								<Col xs={12} md={3}>
									<label className="">7.5 每日必聽</label>
									{/*<ReactPlayer muted={true} controls={true} playing={true} url={process.env.REACT_APP_FILM_API + listItems[0].ent_film} width="100%" height="auto" />*/}
									<ReactPlayer muted={true} controls={true} playing={false} url={process.env.REACT_APP_FILM_API + "7.5每日必聽.mp4"} width="100%" height="150px" />
								</Col>
								<Col xs={0.5}></Col>
								</Row>

								<Row>
								<Col xs={0.5}></Col>
							
								<Col xs={12} md={3}>
									<label>7.6 貼心提醒</label>
									{/*<ReactPlayer muted={true} controls={true} playing={true} url={process.env.REACT_APP_FILM_API + listItems[0].ent_film} width="100%" height="auto" />*/}
									<ReactPlayer muted={true} controls={true} playing={false} url={process.env.REACT_APP_FILM_API + "7.6貼心提醒.mp4"} width="100%" height="150px" />
								</Col>
								<Col xs={1}></Col>
								<Col xs={12} md={3}>
									<label>7.7 鬧鐘</label>
									{/*<ReactPlayer muted={true} controls={true} playing={true} url={process.env.REACT_APP_FILM_API + listItems[0].ent_film} width="100%" height="auto" />*/}
									<ReactPlayer muted={true} controls={true} playing={false} url={process.env.REACT_APP_FILM_API + "7.7鬧鐘.mp4"} width="100%" height="150px" />
								</Col>
								<Col xs={1}></Col>
								<Col xs={12} md={3}>
									<label>8.技能啟用</label>
									{/*<ReactPlayer muted={true} controls={true} playing={true} url={process.env.REACT_APP_FILM_API + listItems[0].ent_film} width="100%" height="auto" />*/}
									<ReactPlayer muted={true} controls={true} playing={false} url={process.env.REACT_APP_FILM_API + "8.技能啟用.mp4"} width="100%" height="150px" />
								</Col>
								</Row>

								<Row>
								<Col xs={0.5}></Col>
							
								<Col xs={12} md={3}>
									<label>8.1技能介紹</label>
									{/*<ReactPlayer muted={true} controls={true} playing={true} url={process.env.REACT_APP_FILM_API + listItems[0].ent_film} width="100%" height="auto" />*/}
									<ReactPlayer muted={true} controls={true} playing={false} url={process.env.REACT_APP_FILM_API + "8.1技能介紹.mp4"} width="100%" height="150px" />
								</Col>
								<Col xs={1}></Col>
								<Col xs={12} md={3}>
									<label>9.內容</label>
									{/*<ReactPlayer muted={true} controls={true} playing={true} url={process.env.REACT_APP_FILM_API + listItems[0].ent_film} width="100%" height="auto" />*/}
									<ReactPlayer muted={true} controls={true} playing={false} url={process.env.REACT_APP_FILM_API + "9.內容.mp4"} width="100%" height="150px" />
								</Col>
								<Col xs={1}></Col>
								<Col xs={12} md={3}>
									<label>10.1 線上申租方案(固網)</label>
									{/*<ReactPlayer muted={true} controls={true} playing={true} url={process.env.REACT_APP_FILM_API + listItems[0].ent_film} width="100%" height="auto" />*/}
									<ReactPlayer muted={true} controls={true} playing={false} url={process.env.REACT_APP_FILM_API + "10.1聲控啟用服務(固網).mp4"} width="100%" height="150px" />
								</Col>
								</Row>

								<Row>
								<Col xs={0.5}></Col>
						
								<Col xs={12} md={3}>
									<label>10.2 線上申租方案(4G)</label>
									{/*<ReactPlayer muted={true} controls={true} playing={true} url={process.env.REACT_APP_FILM_API + listItems[0].ent_film} width="100%" height="auto" />*/}
									<ReactPlayer muted={true} controls={true} playing={false} url={process.env.REACT_APP_FILM_API + "10.2聲控啟用服務(4G).mp4"} width="100%" height="150px" />
								</Col>
								<Col xs={1}></Col>
								<Col xs={12} md={3}>
									<label>11.小額付款/信用卡付費</label>
									{/*<ReactPlayer muted={true} controls={true} playing={true} url={process.env.REACT_APP_FILM_API + listItems[0].ent_film} width="100%" height="auto" />*/}
									<ReactPlayer muted={true} controls={true} playing={false} url={process.env.REACT_APP_FILM_API + "11.資費相關.mp4"} width="100%" height="150px" />
								</Col>
								<Col xs={1}></Col>
								<Col xs={12} md={3}>
									<label>11.小額付款/信用卡付費</label>
									{/*<ReactPlayer muted={true} controls={true} playing={true} url={process.env.REACT_APP_FILM_API + listItems[0].ent_film} width="100%" height="auto" />*/}
									<ReactPlayer muted={true} controls={true} playing={false} url={process.env.REACT_APP_FILM_API + "11.資費相關.mp4"} width="100%" height="150px" />
								</Col>
		
								
								</Row>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>						
	</div>

	)
}

export default Teaching02;